/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{createMotionComponent as n}from"../../motion/index.js";function e(e){function t(t,o={}){return n(e(t,o))}if("undefined"==typeof Proxy)return t;const o=new Map;return new Proxy(t,{get:(n,e)=>(o.has(e)||o.set(e,t(e)),o.get(e))})}export{e as createMotionProxy};
//# sourceMappingURL=motion-proxy.js.map
